import { CloseOutlined, WeiboCircleOutlined } from '@ant-design/icons';
import styles from './ProfileHeader.module.css';
import { Switch, Typography } from 'antd';
import { useContext, useMemo } from 'react';
import { AppContext } from '../../../App';
import { formatToINR } from '../../../Utils/utils';

type AppContextType = {
  isAmountVisible: boolean;
};

export type ProfileHeaderProps = {
  title: string;
  subHeader: string;
  total: string;
  handleBackNavigation: () => void;
  onChange: (checked: boolean) => void;
};

const ProfileHeader = ({
  title,
  subHeader,
  total,
  handleBackNavigation,
  onChange,
}: ProfileHeaderProps) => {
  const { isAmountVisible } = useContext(AppContext) as AppContextType;
  const { Text } = Typography;

  return (
    <div className={styles.wrapper}>
      <div className={styles.profileContainer}>
        <div className={styles.close}>
          <CloseOutlined
            width={14}
            height={14}
            onClick={handleBackNavigation}
          />
        </div>
        <div className={styles.toggleContainer}>
          <Text type='secondary' className={styles.labelToggle}>
            {isAmountVisible ? 'Hide Balances' : 'Show Balances'}
          </Text>

          <Switch
            value={isAmountVisible}
            onChange={onChange}
            className={styles.switch}
          />
        </div>
      </div>
      <div className={styles.profile}>
        <div className={styles.profileDetails}>
          <Text strong className={styles.title}>
            {title}
          </Text>
          <Text className={styles.label}>{subHeader}</Text>
        </div>

        <div className={styles.profileWorth}>
          <Text>Total Net Worth</Text>
          <Text>{formatToINR(total, isAmountVisible)}</Text>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;
